import { useEffect } from "react";

export default function usePageTitle(suffix) {
  useEffect(() => {
    const base = "Nove Zero Due";
    document.title = suffix ? `${suffix} — ${base}` : base;
  }, [suffix]);
}
